<template>
  <b-modal id="dream_wrapper" title="Log my Dream" size="lg" ref="mobileViewHack">
    <div class="row">
      <div class="col-12 mb-2" ref="title">
        <p class="p-0 m-0 mt-3"><b>Title</b></p>
        <div v-if="readonly == 0">
          <small class="text-danger" v-if="!dream.title">Give this dream a title...</small>
          <b-form-input
            id="elm_title"
            v-model="dream.title"
            placeholder="Title for your dream"
            @focus="focusInput('title')"
            autofocus
          ></b-form-input>
        </div>
        <div v-else v-text="dream.title"></div>
      </div>

      <div class="col-12 mb-2" ref="date" v-if="status === 'edit'">
        <p class="p-0 m-0 mt-3"><b>Date</b></p>
        <div v-text="dream.date_human"></div>
      </div>

      <div class="col-12 mb-2" ref="text">
        <p class="p-0 m-0 mt-3"><b>What happened in your dream?</b></p>
        <div v-if="readonly == 0">
          <small class="text-danger" v-if="!dream.main_text || dream.main_text.length < 10">
            What do you remember? (min 10 characters)
          </small>
          <b-form-textarea
            id="elm_text"
            v-model="dream.main_text"
            placeholder="What do you remember?"
            rows="10"
            max-rows="12"
            class="mt-2"
            :state="dream.main_text?.length >= 10"
            @focus="focusInput('text')"
          ></b-form-textarea>
        </div>
        <div v-else v-html="dream.main_text"></div>
      </div>

      <div
        v-if="dream.youtube?.length || dream.vimeo?.length"
        class="col-12 mb-2"
      >
        <video-embeds :embeddata="dream" classW="" show_title="0" />
      </div>

      <div class="col-12 mb-2 border-top">
        <div v-if="readonly == 0">
          <p class="p-0 m-0 mt-3 col-12"><b>Privacy</b></p>
          <div class="col-12">
            <b-form-checkbox v-model="dream.can_comment" switch>
              Comments - <small>turned on, comments are active</small>
            </b-form-checkbox>
          </div>
        </div>
        <div v-else class="text-right">
          <p class="p-0 m-0 mt-3 col-12"><b>Privacy</b></p>
          Comments: <b v-text="dream.can_comment"></b><br />
        </div>
      </div>

      <div v-if="dream.replies" class="col-12 pt-2 mb-4 border-top">
        <h5 class="gold">Replies</h5>

        <div
          v-for="R in dream.replies"
          :key="R.id"
          :class="'R_' + R.id"
          class="mb-4 pb-2 border-bottom"
        >
          <div class="row">
            <div class="col-md-12">
              <p class="small">
                <i class="fas fa-user"></i>
                <span v-text="R.user_name"></span><br />
                <i class="far fa-clock"></i>
                <span v-text="R.access.date"></span> -
                <span v-text="R.access.time" class="mr-2"></span>
              </p>
              <p>
                <b v-text="R.title"></b>
              </p>
              <div>
                <span v-html="R.main_text"></span>
              </div>
            </div>
          </div>

          <div
            v-if="R.youtube?.length || R.vimeo?.length"
          >
            <video-embeds :embeddata="R" classW="col-md-6 mb-2" />
          </div>
        </div>
      </div>

      <div v-if="readonly == 1" class="col-12 mb-2 mt-2 border-top">
        <p class="p-0 m-0 mt-3"><b>Comments/Reply</b></p>
        <b-form-textarea
          v-model="dream_reply"
          placeholder="Add your comment/reply here"
          rows="6"
          max-rows="10"
          class="mt-2"
        ></b-form-textarea>
        <b-button size="sm" variant="primary" @click="replyAdd()"> Add Comment </b-button>
      </div>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <div>
        <div v-if="readonly == 0">
          <button
            type="button"
            class="btn btn-primary"
            @click="submit()"
          >
            <i class="fas fa-cloud-meatball fa-1x"></i>
            <span v-if="status == 'add'">Log</span><span v-else>Edit</span> Dream
          </button>

          <b-button
            v-if="status === 'edit'"
            size="sm"
            variant="outline-danger"
            @click="remove()"
          >
            <i class="fas fa-trash-alt"></i> Delete
          </b-button>
          <b-button size="sm" variant="outline-secondary" @click="cancel()">
            Close
          </b-button>
        </div>
        <div v-else>
          <b-button size="sm" variant="outline-secondary" @click="cancel()">
            Close
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>

</template>

<script>

import axios from 'axios'
import VideoEmbeds from "@/components/VideoEmbeds";

export default {
  components: {
    VideoEmbeds,
  },
  props: {
    readonly: {
      type: Number,
      default: 1,
    },
    activeDream: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      default: 'add'
    }
  },
  watch: {
    activeDream: {
      handler(newVal) {
        this.dream = { ...newVal };
      },
      deep: true
    }
  },
  data() {
    return {
      dream: {...this.activeDream},
      dream_reply: '',
    }
  },
  methods: {
    focusInput(elm) {
      console.log(elm);
      setTimeout(() => {
        this.$refs[elm]?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start',
        });
      }, 1000);
    },
    checkSubmit() {
      return this.dream.title && this.dream.main_text && this.dream.main_text.length >= 10
    },
    replyAdd() {
      if (! this.dream_reply) {
        return
      }
      const params = new URLSearchParams();
      params.append('token', this.$store.state.session_id);
      params.append('main_text', this.dream_reply);
      params.append('post_id', this.dream.id);
      params.append('view_user_id', this.userid);

      axios({
        method: 'post',
        url: this.$store.state.api_url + 'dreamReply',
        data: params,
      })
        .then(response => {
          if (response.data.status) {
            this.$emit('submitted')
            this.dream_reply = '';
          }
        })
    },
    submit: function () {

      if (!this.checkSubmit()) {
        return false;
      }

      const params = new URLSearchParams();
      params.append('token', this.$store.state.session_id);
      params.append('date', this.dream.date_edit);
      params.append('dream_text', this.dream.main_text);
      params.append('dream_title', this.dream.title);
      params.append('dream_comments', this.dream.can_comment);

      if (this.status === 'edit') {
        params.append('forum_id', this.dream.id);
      }

      axios({
        method: 'post',
        url: this.$store.state.api_url + 'dreamAdd',
        data: params,
      })
        .then(() => {
          this.$emit('submitted')
        });
    },
    remove() {
      const c = confirm('Are you sure!');
      if (! c) {
        return
      }

      const params = new URLSearchParams();
      params.append('token', this.$store.state.session_id);
      params.append('forum_id', this.dream.id);

      axios({
        method: 'post',
        url: this.$store.state.api_url + 'dreamRemove',
        data: params,
      })
        .then(() => {
          this.$emit('submitted')
        })
    },
  }
}
</script>
